export const formatSupportDate = (input: string): string => {
    const date = new Date(input);
    const now = new Date();

    const formatDatePart = (d: Date) =>
        new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const datePart = formatDatePart(date);
    const todayPart = formatDatePart(now);

    const diffInDays =
        (todayPart.getTime() - datePart.getTime()) / (1000 * 60 * 60 * 24);

    const pad = (n: number) => n.toString().padStart(2, "0");
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    if (diffInDays === 0) {
        return `Today ${hours}:${minutes}`;
    } else if (diffInDays === 1) {
        return `Yesterday ${hours}:${minutes}`;
    } else {
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        return `${day}.${month}.${year} ${hours}:${minutes}`;
    }
};
